export const DEFAULT_WZ_FILTER_VALUES = {
    'date-period': '0',
    'document-type': 'all',
    receiver: '',
    'product-ean': '',
    'product-index': '',
};
